import {
  AspectRatio,
  ContextType,
  DesignPackageDetail,
  DesignPackageSummary,
  PackageStatus,
} from "@/services/bedrock/dtos/DesignPackage";

export const CONTEXT_TYPE_LABELS: Record<ContextType, string> = {
  review: "Reviews",
  player: "Personal brand",
  none: "General",
};

export const ASPECT_RATIO_LABELS: Record<AspectRatio, string> = {
  square_1_1: "1:1",
  portrait_4_5: "4:5",
  portrait_9_16: "9:16",
};

export const FORMAT_LABELS = { single: "Single image", carousel: "Carousel" };

export type PillKind = "generating" | "updating" | "draft" | "published" | "failed" | "archived";

export type PillInput = Pick<DesignPackageSummary, "status" | "publishedAt" | "archived"> & {
  inFlight?: DesignPackageDetail["inFlight"];
};

const TERMINAL_STATUSES: PackageStatus[] = ["completed", "failed"];

export function isInFlightStatus(status: PackageStatus): boolean {
  return !TERMINAL_STATUSES.includes(status);
}

/** First match wins: archived, generating, failed, refining, published, draft. */
export function pillFor(pkg: PillInput): { kind: PillKind; label: string; className: string } {
  if (pkg.archived) return { kind: "archived", label: "Archived", className: "bg-slate-100 text-slate-500" };
  if (isInFlightStatus(pkg.status))
    return { kind: "generating", label: "Generating", className: "bg-indigo-50 text-primary" };
  if (pkg.status === "failed") return { kind: "failed", label: "Failed", className: "bg-red-50 text-red-700" };
  if (pkg.inFlight?.kind === "refine")
    return { kind: "updating", label: "Updating…", className: "bg-indigo-50 text-primary" };
  if (pkg.publishedAt) return { kind: "published", label: "Published", className: "bg-emerald-50 text-emerald-700" };
  return { kind: "draft", label: "Draft", className: "bg-slate-100 text-slate-600" };
}
